import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './styling/slider.css';

import image1 from './assets/slider/NewStore1.webp';
import image2 from './assets/slider/NewStore2.webp';
import image3 from './assets/slider/NewStore3.webp';
import image4 from './assets/slider/NewStore4.webp';
import image5 from './assets/slider/NewStore5.webp';
import image6 from './assets/slider/NewStore6.webp';
import image7 from './assets/slider/NewStore7.webp';
import image8 from './assets/slider/NewStore8.webp';
import image9 from './assets/slider/NewStore9.webp';
import image10 from './assets/slider/NewStore10.webp';
import image11 from './assets/slider/NewStore11.webp';
import image12 from './assets/slider/NewStore12.webp';
import image13 from './assets/slider/NewStore13.webp';
import image14 from './assets/slider/NewStore14.webp';
import image15 from './assets/slider/NewStore15.webp';
import image16 from './assets/slider/NewStore16.webp';
import image17 from './assets/slider/NewStore17.webp';
import image18 from './assets/slider/NewStore18.webp';
import image19 from './assets/slider/NewStore19.webp';
import image20 from './assets/slider/NewStore20.webp';
import image21 from './assets/slider/NewStore21.webp';
import image22 from './assets/slider/NewStore22.webp';
import image23 from './assets/slider/NewStore23.webp';
import image24 from './assets/slider/NewStore24.webp';

const ImageSlider = () => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  const slider1 = useRef(null);
  const slider2 = useRef(null);

  const settingsMain = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: false,
      onInit: () => {
      setTimeout(() => {
        slider1.current?.slickGoTo(0, true);
        window.dispatchEvent(new Event("resize"));
      }, 0);
    },
    responsive: [
      {
        breakpoint: 2024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5
        }
      },
      {
        breakpoint: 1624,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1324,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,          
          arrows:true,
          dots:true,
        }
      }
    ],
  };

    useEffect(() => {
    const t = setTimeout(() => {
      slider1.current?.slickGoTo(0, true);
      window.dispatchEvent(new Event("resize"));
    }, 50);

    return () => clearTimeout(t);
  }, []);

  const images = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
  image18,
  image19,
  image20,
  image21,
  image22,
  image23,
  image24
];

  return (
    <div data-aos="zoom-in-up" id='sliderBox'>
      {/* Main Image Slider */}
      <Slider
        {...settingsMain}
        ref={(slider) => setNav1(slider)}
        className="slider-for"
      >
        {images.map((image, index) => (
          <div key={index}>
            <img
              src={image}
              alt={`slide-${index}`}
              style={{ width: '100%', height: '600px', objectFit: 'cover' }}
            />
          </div>
        ))}
      </Slider>

      {/* Thumbnail Slider */}
      {/* <Slider
        ref={(slider) => setNav2(slider)}
        className="slider-nav"
      >
        
      </Slider> */}
    </div>
  );
};

export default ImageSlider;
